"use client";

import { Carousel } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import Image from "next/image";
import type { CSSProperties } from "react";
import {
  dirk,
  eric,
  kai,
  violetta,
} from "../../../../public/images/testimonials";

const TestimonialCarousel = () => {
  const t = useTranslations("home.testimonials");

  const testimonials = [
    {
      src: dirk,
      alt: "Dirk Beller / Engel & Völkers Commercial GmbH",
      name: t("dirk.name"),
      titel: t("dirk.titel"),
      text: t("dirk.text"),
    },
    {
      src: kai,
      alt: "Kai Koschella / I.W.A.-Koschella-Immobilien GmbH",
      name: t("kai.name"),
      titel: t("kai.titel"),
      text: t("kai.text"),
    },
    {
      src: eric,
      alt: "Eric Andersen / Andersen Immobilien & Projektierung GmbH",
      imageFit: "contain",
      name: t("eric.name"),
      titel: t("eric.titel"),
      text: t("eric.text"),
    },
    {
      src: violetta,
      alt: "Violetta Kielpinski / Kielpinski & Co. Immobilien GmbH & Co. KG",
      imageFit: "contain",
      name: t("violetta.name"),
      titel: t("violetta.titel"),
      text: t("violetta.text"),
    },
  ];

  return (
    <Carousel
      items={testimonials.map((testimonial, i) => (
        <div
          key={i}
          className="gs--testimonial-card border-primary flex w-full flex-col self-start overflow-hidden border-1 min-[870px]:h-full min-[870px]:flex-row min-[870px]:self-stretch"
        >
          <div
            className="gs--testimonial-card__image-col"
            style={
              {
                "--testimonial-image-position":
                  testimonial.imagePosition ?? "center",
                "--testimonial-image-fit": testimonial.imageFit ?? "cover",
                "--testimonial-image-scale": testimonial.imageScale ?? "1",
              } as CSSProperties
            }
          >
            <Image
              src={testimonial.src}
              alt={testimonial.alt}
              loading="lazy"
              unoptimized
            />
          </div>

          <div className="bg-primary min-w-0 p-6 break-words text-white min-[870px]:flex-1 min-[870px]:py-[1.125rem]">
            <h3 className="text-xl font-bold">{testimonial.name}</h3>
            <p className="text-sm">{testimonial.titel}</p>
            <p className="mt-2">{testimonial.text}</p>
          </div>
        </div>
      ))}
      fullSize
      autoPlay
      autoPlayOptions={{ delay: 6000, stopOnInteraction: false }}
      options={{ loop: true }}
    />
  );
};

export default TestimonialCarousel;
